var map = {
	"./agreement-pic-old.png": "21f3",
	"./agreement-pic.png": "6172",
	"./agreement.png": "2a8f",
	"./bar-bg.png": "db43",
	"./clock.png": "2451",
	"./detection.png": "8369",
	"./dig.png": "d45a2",
	"./environment.png": "28a6",
	"./feature-bg.png": "7ddb",
	"./feature.png": "89f5",
	"./footer-symbol.png": "9140",
	"./lab-feature-icon.png": "31e6",
	"./lab-icon-old.png": "a811",
	"./lab-icon.png": "c991",
	"./lab-room-bg.png": "b472",
	"./lab-room-one.png": "4016",
	"./lab-room-partner.png": "833d",
	"./lab-room-two.png": "1d58",
	"./law.png": "da69",
	"./paper-1.png": "8ea0",
	"./paper-2.png": "6ef2",
	"./paper-3.png": "dc76",
	"./paper-4.png": "1c86",
	"./paper-5.png": "2e4e",
	"./paper-6.png": "775d",
	"./paper-7.png": "8489",
	"./paper-8.png": "923d",
	"./paper-9.png": "de16",
	"./response.png": "63b9",
	"./right-icon.png": "d5b5",
	"./right-part.png": "352a",
	"./title-bg.png": "8aa55",
	"./title-pic.png": "3aec"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "af0f";